/**
 * Singleton store tracking eventIds whose video execution has finished.
 * Used by useScheduleStatus to flip phase to 'ended' immediately on execution
 * end, without waiting for end_timestamp to be crossed by the clock.
 *
 * Pattern mirrors shared/queries/serverTime.ts (subscribe/getSnapshot for
 * useSyncExternalStore).
 */

const listeners = new Set<() => void>();
const endedEventIds = new Set<string>();
let snapshot = 0;

function emit() {
  snapshot += 1;
  for (const l of listeners) l();
}

export function markExecutionEnded(eventId: string | number | null | undefined): void {
  if (eventId == null) return;
  const key = String(eventId);
  if (endedEventIds.has(key)) return;
  endedEventIds.add(key);
  emit();
}

export function isExecutionEndedForEvent(eventId: string | number | null | undefined): boolean {
  if (eventId == null) return false;
  return endedEventIds.has(String(eventId));
}

export function clearExecutionEnded(eventId: string | number | null | undefined): void {
  if (eventId == null) return;
  const key = String(eventId);
  if (!endedEventIds.has(key)) return;
  endedEventIds.delete(key);
  emit();
}

export function subscribeExecutionEnded(cb: () => void): () => void {
  listeners.add(cb);
  return () => { listeners.delete(cb); };
}

export function getExecutionEndedSnapshot(): number {
  return snapshot;
}
